import { QrGateway } from '../model/qrGateway';

export const QrGatewayEntity = ({ qr }: QrGateway): Readonly<QrGateway> => {
  return Object.freeze({
    qr,
  });
};
